import SkillsInterestsForm from './skillsInterestsForm'
export default SkillsInterestsForm
